import type { BasePrompt } from '~~/src/types/prompt'

export const MOCK_PROMPTS: BasePrompt[] = [
  {
    id: '1',
    title: 'Testing Prompt',
    isVoted: true,
    isSaved: false,
    nVotes: 300,
    nSaves: 0,
    nUses: 0,
    description: 'This is a testing prompt',
    isPremium: false,
    isPrivate: false,
    template: 'Test',
    url: '1',
    shareImage: '',
    isTutorialHidden: false,
    createdAt: (new Date()).toISOString(),
    topicIds: [],
    tutorialStep: [],
    images: { cover: [], output: [] },
    user: {
      id: 'invalidId',
      name: 'Invalid User',
      username: 'invalid_user',
      avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
    },
    isPrompt: true,
  },
  {
    id: '1',
    title: 'An amazing test Prompt',
    isVoted: false,
    isSaved: false,
    nVotes: 1,
    nSaves: 0,
    nUses: 0,
    description: 'This is a testing prompt',
    isPremium: false,
    isPrivate: false,
    template: 'Test',
    url: '1',
    shareImage: '',
    isTutorialHidden: false,
    createdAt: (new Date()).toISOString(),
    topicIds: [],
    tutorialStep: [],
    images: { cover: [], output: [] },
    user: {
      id: 'invalidId',
      name: 'Invalid User',
      username: 'invalid_user',
      avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
    },
    isPrompt: true,
  },
  {
    id: '1',
    title: 'An amazing test Prompt',
    isVoted: false,
    isSaved: false,
    nVotes: 1,
    nSaves: 0,
    nUses: 0,
    description: 'This is a testing prompt',
    isPremium: false,
    isPrivate: false,
    template: 'Test',
    url: '1',
    shareImage: '',
    isTutorialHidden: false,
    createdAt: (new Date()).toISOString(),
    topicIds: [],
    tutorialStep: [],
    images: { cover: [], output: [] },
    user: {
      id: 'invalidId',
      name: 'Invalid User',
      username: 'invalid_user',
      avatar: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
    },
    isPrompt: true,
  },
]
